import React from 'react';

const NotFoundPage = () => {
    return (
        <main>
            <div className="container">
                <div className="row">
                    <div className="col-12">
                        <section className="my-5 text-center">
                            <h1 className="display-1">404</h1>
                            <h4 className="mb-4">Page not found</h4>
                            <p className="mb-0">The Page you are looking for doesn't exist or another error occurred.</p>
                            <p className="mb-4">Go back, or head over to login to choose a new direction.</p>
                            <a href="/login">
                                <button className="ripple ripple-surface btn btn-primary" role="button">
                                    Go back to Login
                                </button>
                            </a>
                        </section>
                    </div>
                </div>
            </div>
        </main>
    );
};

export default NotFoundPage;
